<template>
	<button
		class="product-like"
		aria-label="В избранное"
		type="button"
		:class="{ 'product-like--active': isActive }"
		@click="handleClick"
	>
	</button>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

interface Props {
	id: string;
}

const props = defineProps<Props>();

const store = window.app.store.favourites;
const isActive = computed(() => store.isInFavourites(props.id));

const handleClick = (): void => store.setFavourite(props.id);
</script>
